/* eslint-disable import/prefer-default-export */
import { addLoading, removeLoading } from './loading';
import ProductFeedbackServer from '../../server/productFeedback';

export const sendProductFeedback = (
  productSoneparId, websiteReview, productFeedbackReasonId, feedback,
) => async (dispatch, getState) => {
  dispatch(addLoading());
  try {
    const selectedContract = getState().contracts.selected;
    if (selectedContract) {
      const { client = {}, userId } = selectedContract;
      await ProductFeedbackServer.sendProductFeedback(
        client.id, userId, productSoneparId, websiteReview, productFeedbackReasonId, feedback,
      );
    }
  } finally {
    dispatch(removeLoading());
  }
};
